import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsShow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowsShow"><Path d="M13 18.5859L14.293 17.293L15.707 18.707L12 22.4141L8.29297 18.707L9.70703 17.293L11 18.5859V14H13V18.5859ZM8 10H4V14H8V16H2V8H8V10ZM22 16H16V14H20V10H16V8H22V16ZM15.707 5.29297L14.293 6.70703L13 5.41406V10H11V5.41406L9.70703 6.70703L8.29297 5.29297L12 1.58594L15.707 5.29297Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsShow;
